export const chatResultsMock = {
  viewType: 'hotel-list',
  viewData: {
    query: 'Luxury hotels in a historic European capital and two culturally rich Italian cities.',
    rawData: {
      data: {
        search: {
          conversationalSearch: {
            searchByNaturalLanguageQuery: {
              llmMetadata: {
                isLlmEngaged: true,
                llmInfo: {
                  queryRewrite: 'Luxury hotels in a historic European capital and two culturally rich Italian cities.',
                  callTimes: {
                    dateCall: 0.6446533203125,
                    locationCall: 1.1207795143127441,
                    priceCall: 0.6234240531921387,
                    queryRewrite: 0.5417304039001465,
                  },
                  date: {
                    earliest: '2026-04-15',
                    latest: '2026-04-22',
                    length: 7,
                    type: 'EXACT',
                  },
                  location: {
                    intent: 'luxury travel',
                    recommendations: [
                      {
                        city: 'Rome',
                        country: 'Italy',
                        latitude: 41.9028,
                        locationName: null,
                        longitude: 12.4964,
                        state: null,
                      },
                      {
                        city: 'Florence',
                        country: 'Italy',
                        latitude: 43.7696,
                        locationName: null,
                        longitude: 11.2558,
                        state: null,
                      },
                      {
                        city: 'Venice',
                        country: 'Italy',
                        latitude: 45.4388,
                        locationName: null,
                        longitude: 12.3359,
                        state: null,
                      },
                    ],
                  },
                  price: {
                    currency: 'USD',
                    maximum: null,
                    minimum: '0',
                  },
                },
              },
              pageInfo: {
                hasNextPage: false,
                hasPreviousPage: false,
                previousOffset: null,
                currentOffset: 0,
                nextOffset: null,
              },
              total: 7,
              facets: [
                {
                  type: {
                    code: 'brands',
                    label: 'Brands',
                    count: 5,
                    description: 'Brands',
                  },
                  buckets: [
                    {
                      code: 'BG',
                      label: 'Bvlgari',
                      description: 'BG',
                      count: 1,
                    },
                    {
                      code: 'EB',
                      label: 'EDITION',
                      description: 'EB',
                      count: 1,
                    },
                    {
                      code: 'XR',
                      label: 'St. Regis',
                      description: 'XR',
                      count: 3,
                    },
                    {
                      code: 'LC',
                      label: 'The Luxury Collection',
                      description: 'LC',
                      count: 1,
                    },
                    {
                      code: 'WH',
                      label: 'W Hotels',
                      description: 'WH',
                      count: 1,
                    },
                  ],
                },
                {
                  type: {
                    code: 'activities-on-site',
                    label: 'Activities',
                    count: 1,
                    description: 'Activities On-site',
                  },
                  buckets: [
                    {
                      code: 'spa',
                      label: 'Full service spa',
                      description: 'Full service spa',
                      count: 5,
                    },
                  ],
                },
                {
                  type: {
                    code: 'transportation-types',
                    label: 'Transportation',
                    count: 1,
                    description: 'Transportation types',
                  },
                  buckets: [
                    {
                      code: 'parking',
                      label: 'Parking',
                      description: 'Parking',
                      count: 5,
                    },
                  ],
                },
                {
                  type: {
                    code: 'amenities',
                    label: 'Amenities',
                    count: 14,
                    description: 'Amenities',
                  },
                  buckets: [
                    {
                      code: 'business-center',
                      label: 'Business center',
                      description: 'Business center',
                      count: 5,
                    },
                    {
                      code: 'ev-charging',
                      label: 'EV Charging',
                      description: 'EV Charging',
                      count: 1,
                    },
                    {
                      code: 'fitness-center',
                      label: 'Fitness center',
                      description: 'Fitness center',
                      count: 7,
                    },
                    {
                      code: 'breakfast',
                      label: 'Free breakfast',
                      description: 'Free breakfast',
                      count: 1,
                    },
                    {
                      code: 'free-internet',
                      label: 'Free high-speed internet',
                      description: 'Free high-speed internet',
                      count: 6,
                    },
                    {
                      code: 'internet',
                      label: 'High-speed Internet',
                      description: 'High-speed internet at a price',
                      count: 6,
                    },
                    {
                      code: 'kitchen',
                      label: 'Kitchen',
                      description: 'Kitchen',
                      count: 1,
                    },
                    {
                      code: 'kitchenette',
                      label: 'Kitchenette',
                      description: 'Kitchenette',
                      count: 1,
                    },
                    {
                      code: 'pet-friendly',
                      label: 'Pets welcome',
                      description: 'Pet friendly',
                      count: 7,
                    },
                    {
                      code: 'pool',
                      label: 'Pool',
                      description: 'Pool',
                      count: 3,
                    },
                    {
                      code: 'restaurant-on-site',
                      label: 'Restaurant on-site',
                      description: 'Restaurant on-site',
                      count: 7,
                    },
                    {
                      code: 'room-service',
                      label: 'Room service',
                      description: 'Room service',
                      count: 1,
                    },
                    {
                      code: 'whirlpool-in-room',
                      label: 'Whirlpool in Room',
                      description: 'Whirlpool in Room',
                      count: 1,
                    },
                    {
                      code: 'whirlpool-on-site',
                      label: 'Whirlpool on Site',
                      description: 'Whirlpool on Site',
                      count: 1,
                    },
                  ],
                },
                {
                  type: {
                    code: 'meetings-and-events',
                    label: 'Events',
                    count: 2,
                    description: 'Meeting and events',
                  },
                  buckets: [
                    {
                      code: 'certified-meeting-planner',
                      label: 'Certified meeting planner',
                      description: 'Certified meeting planner',
                      count: 3,
                    },
                    {
                      code: 'meeting-space',
                      label: 'Meeting event space',
                      description: 'Meeting event space',
                      count: 6,
                    },
                  ],
                },
                {
                  type: {
                    code: 'cities',
                    label: 'City',
                    count: 3,
                    description: 'City',
                  },
                  buckets: [
                    {
                      code: 'Florence',
                      label: 'Florence',
                      description: 'Florence',
                      count: 1,
                    },
                    {
                      code: 'Rome',
                      label: 'Rome',
                      description: 'Rome',
                      count: 4,
                    },
                    {
                      code: 'Venice',
                      label: 'Venice',
                      description: 'Venice',
                      count: 2,
                    },
                  ],
                },
                {
                  type: {
                    code: 'states',
                    label: 'States / Provinces',
                    count: 0,
                    description: 'State Code',
                  },
                  buckets: [],
                },
                {
                  type: {
                    code: 'countries',
                    label: 'Countries / Regions',
                    count: 1,
                    description: 'Country Code',
                  },
                  buckets: [
                    {
                      code: 'IT',
                      label: 'Italy',
                      description: 'Italy',
                      count: 7,
                    },
                  ],
                },
                {
                  type: {
                    code: 'hotel-service-types',
                    label: 'Hotel Service',
                    count: 2,
                    description: 'Hotel service types',
                  },
                  buckets: [
                    {
                      code: 'full-service',
                      label: 'Full service',
                      description: 'Full service',
                      count: 7,
                    },
                    {
                      code: 'luxury',
                      label: 'Luxury',
                      description: 'Luxury',
                      count: 1,
                    },
                  ],
                },
                {
                  type: {
                    code: 'property-types',
                    label: 'Hotel Type',
                    count: 0,
                    description: 'Property types',
                  },
                  buckets: [],
                },
                {
                  type: {
                    code: 'leisure-region',
                    label: 'Leisure Region',
                    count: 1,
                    description: 'Leisure Region',
                  },
                  buckets: [
                    {
                      code: 'europe',
                      label: 'Europe',
                      description: 'Europe',
                      count: 7,
                    },
                  ],
                },
                {
                  type: {
                    code: 'all-inclusive',
                    label: 'All Inclusive',
                    count: 0,
                    description: 'All Inclusive',
                  },
                  buckets: [],
                },
                {
                  type: {
                    code: 'price',
                    label: 'Lowest Available Rate (Cash)',
                    count: 1,
                    description: 'Lowest Available Rate, Cash',
                  },
                  buckets: [
                    {
                      index: 1,
                      start: '0',
                      end: 'overflow',
                      count: 7,
                    },
                  ],
                },
              ],
              status: [
                {
                  __typename: 'ResponseSuccess',
                  code: 'SUCCESS',
                  httpStatus: 200,
                  errors: [],
                  warnings: [
                    {
                      code: 'AMP042',
                      devMessage:
                        'The hotels in this location are unavailable for your dates and/or special rates. Try changing your travel dates and/or special rate request. - D427',
                      message:
                        'The hotels in this location are unavailable for your dates and/or special rates. Try changing your travel dates and/or special rate request. - D427',
                    },
                  ],
                },
              ],
              edges: [
                {
                  node: {
                    distance: null,
                    property: {
                      id: 'FLRXR',
                      basicInformation: {
                        isMax: false,
                        resort: false,
                        isAdultsOnly: false,
                        brand: {
                          id: 'XR',
                          name: 'St. Regis',
                          type: 'SPG',
                          photos: [],
                        },
                        name: 'The St. Regis Florence',
                        nameInDefaultLanguage: 'The St. Regis Florence',
                        descriptions: [
                          {
                            text: 'Standing on the banks of the Arno River with views across to the Ponte Vecchio and the picturesque hills of Tuscany, The St. Regis Florence is the epitome of elegance and refined hospitality, and the preferred stop of tastemakers and luxury hotel travelers since the 18th century. Impeccably placed in the city’s historical center, our 5-star hotel offers an unrivalled immersion into the cradle of the Renaissance. Lavishly appointed accommodations at The St. Regis Florence feature decidedly modern amenities and services, all elevated by the St. Regis hallmark butler service, offering visitors a myriad of storied Florentine aesthetics. Local flavors infuse a gourmet Tuscan cuisine in the hotel’s restaurants and bars, and a selection of elegant venues lend distinction to weddings, social celebrations and business events.  When it is time to wind down, the Iridium Spa Suites in partnership with My Blend by Clarins, present unique, bespoke treatments and in-depth therapies.',
                            type: {
                              code: 'DESCRIPTION',
                              enumCode: 'DESCRIPTION',
                            },
                          },
                          {
                            text: 'The epitome of elegance and refined hospitality, The St. Regis Florence stands on the banks of the Arno river. The finest address in the city, the hotel offers visitors a myriad experience of storied Florentine aesthetics with decidedly modern amenities.',
                            type: {
                              code: 'PROPERTY DESCRIPTION',
                              enumCode: 'SHORT_DESCRIPTION',
                            },
                          },
                          {
                            text: 'The epitome of elegance and refined hospitality, The St. Regis Florence stands on the banks of the Arno river. The finest address in the city, the hotel offers visitors a myriad experience of storied Florentine aesthetics with decidedly modern amenities.',
                            type: {
                              code: 'PROPERTY LONG DESCRIPTION',
                              enumCode: 'LONG_DESCRIPTION',
                            },
                          },
                          {
                            text: "Positioned in the center of the city, The St. Regis Florence is an optimal base from which to explore Tuscany's timeless attractions. A short stroll will bring you to the iconic Uffizzi, Duomo, or Ponte Vecchio’s famous jewelry shops.",
                            type: {
                              code: 'LOCATION',
                              enumCode: 'LOCATION',
                            },
                          },
                          {
                            text: "Positioned in the center of the city, The St. Regis Florence is an optimal base from which to explore Tuscany's timeless attractions. A short stroll will bring you to the iconic Uffizzi, Duomo, or Ponte Vecchio’s famous jewelry shops.",
                            type: {
                              code: 'SALES MESSAGE',
                              enumCode: 'SALES_MESSAGE',
                            },
                          },
                          {
                            text: "The Finest Address in Italy's Renaissance Capital",
                            type: {
                              code: 'HEADER MESSAGE',
                              enumCode: 'HEADER_MESSAGE',
                            },
                          },
                          {
                            text: 'Guestrooms and Suites',
                            type: {
                              code: 'ROOM HEADER CAPTION',
                              enumCode: 'ROOM_HEADER_CAPTION',
                            },
                          },
                          {
                            text: 'The St. Regis Florence is on the Arno river and centrally located for easy exploration of the city.',
                            type: {
                              code: 'HOTEL MARKETING CAPTION',
                              enumCode: 'HOTEL_MARKETING_CAPTION',
                            },
                          },
                        ],
                        currency: 'EUR',
                        isRecentlyRenovated: false,
                        isFullyRenovated: false,
                        hasRenovatedRooms: false,
                        newLobby: false,
                        newProperty: false,
                        openingDate: '1994-11-19',
                        latitude: 43.77208,
                        longitude: 11.24494,
                        bookable: true,
                        hasUniquePropertyLogo: false,
                      },
                      reviews: {
                        stars: {
                          count: 4.8,
                        },
                        numberOfReviews: {
                          count: 613,
                        },
                      },
                      media: {
                        primaryImage: {
                          edges: [
                            {
                              node: {
                                title: 'flrxr-suite-5988',
                                imageUrls: {
                                  wideHorizontal:
                                    '/content/dam/marriott-renditions/FLRXR/flrxr-presidential-suite-balcony-5988-hor-wide.jpg',
                                  square:
                                    '/content/dam/marriott-renditions/FLRXR/flrxr-presidential-suite-balcony-5988-sq.jpg',
                                  classicHorizontal:
                                    '/content/dam/marriott-renditions/FLRXR/flrxr-presidential-suite-balcony-5988-hor-clsc.jpg',
                                },
                              },
                            },
                          ],
                        },
                      },
                    },
                    rates: [
                      {
                        rateModes: {
                          lowestAverageRate: {
                            amount: {
                              amount: 108096,
                              currency: 'EUR',
                              decimalPoint: 2,
                            },
                            fees: {
                              amount: 0,
                              currency: 'EUR',
                              decimalPoint: 2,
                            },
                            taxes: {
                              amount: 800,
                              currency: 'EUR',
                              decimalPoint: 2,
                            },
                            totalAmount: {
                              amount: 108896,
                              currency: 'EUR',
                              decimalPoint: 2,
                            },
                            amountPlusMandatoryFees: {
                              amount: 108096,
                              currency: 'EUR',
                              decimalPoint: 2,
                            },
                            mandatoryFees: {
                              amount: 0,
                              currency: 'EUR',
                              decimalPoint: 2,
                            },
                          },
                        },
                        membersOnly: false,
                        lengthOfStay: 7,
                        status: {
                          code: 'AvailableForSale',
                        },
                        rateCategory: {
                          code: 'StandardRates',
                          value: null,
                        },
                        sourceOfRate: 'DSP',
                      },
                    ],
                  },
                },
                {
                  node: {
                    distance: null,
                    property: {
                      id: 'ROMBG',
                      basicInformation: {
                        isMax: false,
                        resort: false,
                        isAdultsOnly: false,
                        brand: {
                          id: 'BG',
                          name: 'Bvlgari Hotels and Resorts',
                          type: 'Marriott',
                          photos: [
                            {
                              content: [
                                {
                                  alternateText: 'Autograph Collection hotel photography',
                                  index: 1,
                                  name: 'bg_main01',
                                  url: 'https://cache.marriott.com/marriottassets/marriott/BG/bg-main01-0001-hor-feat.jpg',
                                },
                              ],
                              type: {
                                code: 'primary',
                              },
                            },
                          ],
                        },
                        name: 'Bulgari Hotel Roma',
                        nameInDefaultLanguage: 'Bulgari Hotel Roma',
                        descriptions: [
                          {
                            text: 'Bulgari Hotel Roma is now open. The Hotel represents a new expression of the Bulgari spirit in the Eternal City. An instantly iconic destination given Rome’s role as Bulgari’s hometown an endless font of inspiration, the new property occupies an illustrious address at Piazza Augusto Imperatore in the heart of the Campo Marzio district. Bulgari Hotel Roma is home to 114 Rooms and Suites decorated in a color palette inspired by the city, as well as Bulgari Hotels’ signature dining and lifestyle experiences, including Il Ristorante - Niko Romito, the Bulgari Bar, the Lobby Lounge, the Spa, and Italy’s first Bulgari Dolci chocolatier and patisserie.',
                            type: {
                              code: 'DESCRIPTION',
                              enumCode: 'DESCRIPTION',
                            },
                          },
                          {
                            text: 'Bulgari Hotel Roma is an exceptional homage to the home of Bulgari and its greatest source of inspiration.',
                            type: {
                              code: 'PROPERTY DESCRIPTION',
                              enumCode: 'SHORT_DESCRIPTION',
                            },
                          },
                          {
                            text: 'Bulgari Hotel Roma is an exceptional homage to the home of Bulgari and its greatest source of inspiration.',
                            type: {
                              code: 'PROPERTY LONG DESCRIPTION',
                              enumCode: 'LONG_DESCRIPTION',
                            },
                          },
                          {
                            text: 'The Hotel is located in the heart of the Campo Marzio neighborhood, minutes from the Spanish Steps, Via del Corso and the Bulgari flagship on Via Condotti.',
                            type: {
                              code: 'LOCATION',
                              enumCode: 'LOCATION',
                            },
                          },
                          {
                            text: 'The Hotel is located in the heart of the Campo Marzio neighborhood, minutes from the Spanish Steps, Via del Corso and the Bulgari flagship on Via Condotti.',
                            type: {
                              code: 'SALES MESSAGE',
                              enumCode: 'SALES_MESSAGE',
                            },
                          },
                          {
                            text: null,
                            type: {
                              code: 'HEADER MESSAGE',
                              enumCode: 'HEADER_MESSAGE',
                            },
                          },
                          {
                            text: null,
                            type: {
                              code: 'HOTEL MARKETING CAPTION',
                              enumCode: 'HOTEL_MARKETING_CAPTION',
                            },
                          },
                        ],
                        currency: 'EUR',
                        isRecentlyRenovated: false,
                        isFullyRenovated: false,
                        hasRenovatedRooms: false,
                        newLobby: false,
                        newProperty: false,
                        openingDate: '2023-06-09',
                        latitude: 41.90694166724697,
                        longitude: 12.476167611648245,
                        bookable: true,
                        hasUniquePropertyLogo: false,
                      },
                      reviews: {
                        stars: {
                          count: null,
                        },
                        numberOfReviews: {
                          count: null,
                        },
                      },
                      media: {
                        primaryImage: {
                          edges: [
                            {
                              node: {
                                title: 'Bulgari Hotel Rome 23553',
                                imageUrls: {
                                  wideHorizontal:
                                    '/is/image/marriotts7prod/bg-rombg-bulgari-hotel-rome-23553-24889:Wide-Hor',
                                  square: '/is/image/marriotts7prod/bg-rombg-bulgari-hotel-rome-23553-24889:Square',
                                  classicHorizontal:
                                    '/is/image/marriotts7prod/bg-rombg-bulgari-hotel-rome-23553-24889:Classic-Hor',
                                },
                              },
                            },
                          ],
                        },
                      },
                    },
                    rates: [
                      {
                        rateModes: {
                          lowestAverageRate: {
                            amount: {
                              amount: 250000,
                              currency: 'EUR',
                              decimalPoint: 2,
                            },
                            fees: {
                              amount: 0,
                              currency: 'EUR',
                              decimalPoint: 2,
                            },
                            taxes: {
                              amount: 26000,
                              currency: 'EUR',
                              decimalPoint: 2,
                            },
                            totalAmount: {
                              amount: 276000,
                              currency: 'EUR',
                              decimalPoint: 2,
                            },
                            amountPlusMandatoryFees: {
                              amount: 250000,
                              currency: 'EUR',
                              decimalPoint: 2,
                            },
                            mandatoryFees: {
                              amount: 0,
                              currency: 'EUR',
                              decimalPoint: 2,
                            },
                          },
                        },
                        membersOnly: false,
                        lengthOfStay: 7,
                        status: {
                          code: 'AvailableForSale',
                        },
                        rateCategory: {
                          code: 'StandardRates',
                          value: null,
                        },
                        sourceOfRate: 'MARSHA',
                      },
                    ],
                  },
                },
                {
                  node: {
                    distance: null,
                    property: {
                      id: 'ROMEB',
                      basicInformation: {
                        isMax: false,
                        resort: false,
                        isAdultsOnly: false,
                        brand: {
                          id: 'EB',
                          name: 'EDITION',
                          type: 'Marriott',
                          photos: [
                            {
                              content: [
                                {
                                  alternateText: 'EDITION hotel photography',
                                  index: 1,
                                  name: 'eb_main01',
                                  url: 'https://cache.marriott.com/marriottassets/marriott/EB/eb-main01-0001-hor-feat.jpg',
                                },
                                {
                                  alternateText: 'Fairfield Inn Lobby',
                                  index: 2,
                                  name: 'eb_main02',
                                  url: 'https://cache.marriott.com/content/dam/marriott-renditions/FN/ffi-main02-0001-hor-feat.jpg',
                                },
                                {
                                  alternateText: 'EDITION Hotel',
                                  index: 3,
                                  name: 'eb_main03',
                                  url: 'https://cache.marriott.com/content/dam/marriott-renditions/FN/ffi-main03-0001-hor-featr.jpg',
                                },
                              ],
                              type: {
                                code: 'primary',
                              },
                            },
                          ],
                        },
                        name: 'The Rome EDITION',
                        nameInDefaultLanguage: 'The Rome EDITION',
                        descriptions: [
                          {
                            text: 'The Rome EDITION offers uniquely designed food and beverage outlets, including a signature restaurant with outdoor dining space that will make locals and visitors fall in love with its cuisine and all that comes with it, a Punch Room bar with exceptionally crafted cocktails; and a Rooftop Terrace where guests can have the choice of a seasonal bite, a drink overlooking the city, a private gathering with friends, or all of the above. In addition to customizable indoor and outdoor event spaces, the hotel is also home to a rooftop swimming pool, a very spacious hi tech gym, and two treatment rooms including a couple-massage experience. At the corner of modern luxury and history, the hotel is housed within a historical striking building designed by Cesare Pascoletti in collaboration with architect Marcello Piacentini, one of Italy’s most famed architects of Rationalism in the early 20th century.',
                            type: {
                              code: 'DESCRIPTION',
                              enumCode: 'DESCRIPTION',
                            },
                          },
                          {
                            text: 'The Rome EDITION is the first EDITION property in Italy. It features 91 guest rooms and suites. The Rome EDITION offers uniquely designed food and beverage outlets',
                            type: {
                              code: 'PROPERTY DESCRIPTION',
                              enumCode: 'SHORT_DESCRIPTION',
                            },
                          },
                          {
                            text: 'The Rome EDITION is the first EDITION property in Italy. It features 91 guest rooms and suites. The Rome EDITION offers uniquely designed food and beverage outlets',
                            type: {
                              code: 'PROPERTY LONG DESCRIPTION',
                              enumCode: 'LONG_DESCRIPTION',
                            },
                          },
                          {
                            text: 'With its central location a few steps from Via Veneto and Bernini’s Tritone Fountain in Piazza Barberini, The Rome EDITION is within a short walk of all the best that the city has to offer, such as the Spanish Steps, Trevi Fountain and Borghese Garden',
                            type: {
                              code: 'LOCATION',
                              enumCode: 'LOCATION',
                            },
                          },
                          {
                            text: 'With its central location a few steps from Via Veneto and Bernini’s Tritone Fountain in Piazza Barberini, The Rome EDITION is within a short walk of all the best that the city has to offer, such as the Spanish Steps, Trevi Fountain and Borghese Garden',
                            type: {
                              code: 'SALES MESSAGE',
                              enumCode: 'SALES_MESSAGE',
                            },
                          },
                          {
                            text: 'The Rome EDITION',
                            type: {
                              code: 'HEADER MESSAGE',
                              enumCode: 'HEADER_MESSAGE',
                            },
                          },
                          {
                            text: null,
                            type: {
                              code: 'HOTEL MARKETING CAPTION',
                              enumCode: 'HOTEL_MARKETING_CAPTION',
                            },
                          },
                        ],
                        currency: 'EUR',
                        isRecentlyRenovated: false,
                        isFullyRenovated: false,
                        hasRenovatedRooms: false,
                        newLobby: false,
                        newProperty: false,
                        openingDate: '2023-05-16',
                        latitude: 41.90538808330267,
                        longitude: 12.490620752983247,
                        bookable: true,
                        hasUniquePropertyLogo: false,
                      },
                      reviews: {
                        stars: {
                          count: 4.5,
                        },
                        numberOfReviews: {
                          count: 19,
                        },
                      },
                      media: {
                        primaryImage: {
                          edges: [
                            {
                              node: {
                                title: 'Lobby 03 18694',
                                imageUrls: {
                                  wideHorizontal: '/is/image/marriotts7prod/eb-romeb-lobby-03-18694:Wide-Hor',
                                  square: '/is/image/marriotts7prod/eb-romeb-lobby-03-18694:Square',
                                  classicHorizontal: '/is/image/marriotts7prod/eb-romeb-lobby-03-18694:Classic-Hor',
                                },
                              },
                            },
                          ],
                        },
                      },
                    },
                    rates: [
                      {
                        rateModes: {
                          lowestAverageRate: {
                            amount: {
                              amount: 69387,
                              currency: 'EUR',
                              decimalPoint: 2,
                            },
                            fees: {
                              amount: 0,
                              currency: 'EUR',
                              decimalPoint: 2,
                            },
                            taxes: {
                              amount: 7938,
                              currency: 'EUR',
                              decimalPoint: 2,
                            },
                            totalAmount: {
                              amount: 77326,
                              currency: 'EUR',
                              decimalPoint: 2,
                            },
                            amountPlusMandatoryFees: {
                              amount: 69387,
                              currency: 'EUR',
                              decimalPoint: 2,
                            },
                            mandatoryFees: {
                              amount: 0,
                              currency: 'EUR',
                              decimalPoint: 2,
                            },
                          },
                        },
                        membersOnly: false,
                        lengthOfStay: 7,
                        status: {
                          code: 'AvailableForSale',
                        },
                        rateCategory: {
                          code: 'StandardRates',
                          value: null,
                        },
                        sourceOfRate: 'MARSHA',
                      },
                    ],
                  },
                },
                {
                  node: {
                    distance: null,
                    property: {
                      id: 'ROMWV',
                      basicInformation: {
                        isMax: false,
                        resort: false,
                        isAdultsOnly: false,
                        brand: {
                          id: 'WH',
                          name: 'W Hotels',
                          type: 'SPG',
                          photos: [],
                        },
                        name: 'W Rome',
                        nameInDefaultLanguage: 'W Rome',
                        descriptions: [
                          {
                            text: "Historic palazzo on the outside, a bold interpretation of luxury inside, W Rome celebrates the Italian attitude and captures the energy of the Eternal City. With its 162 rooms and suites, design twist and vibrant experiences, the hotel marks the W Hotels entry to the scene in an unapologetically Italian way, starting from the taste experiences with Head chef Ciccio Sultano who shakes up the city's foodie scene with authentic Sicilian cooking served at Giano Restaurant. Loaded with Roman vitality yet dismantling the norm, W Rome has something for everyone, whether it be a sweet retreat at Zucchero x Fabrizio Fiorani, a cocktail with upbeat music at W Lounge or live entertainment at Giardino Clandestino. On the upper floor, striking views of the city make Seu Pizza con Vista, in collaboration with Pier Daniele Seu, and WET Deck even more exceptional. Owning the Eternal City mindset, W Rome calls out the past, present and future to remix tradition and defy boundaries.",
                            type: {
                              code: 'DESCRIPTION',
                              enumCode: 'DESCRIPTION',
                            },
                          },
                          {
                            text: 'Historic palazzo on the outside, a bold distortion of luxury inside, W Rome celebrates the duality of Italy and captures the energy of the Eternal City.',
                            type: {
                              code: 'PROPERTY DESCRIPTION',
                              enumCode: 'SHORT_DESCRIPTION',
                            },
                          },
                          {
                            text: 'Historic palazzo on the outside, a bold distortion of luxury inside, W Rome celebrates the duality of Italy and captures the energy of the Eternal City.',
                            type: {
                              code: 'PROPERTY LONG DESCRIPTION',
                              enumCode: 'LONG_DESCRIPTION',
                            },
                          },
                          {
                            text: 'Located on Via Liguria, next to the Spanish Steps. Historic palazzo on the outside, a bold distortion of luxury inside, W Rome enters the scene in an unapologetically Italian way.',
                            type: {
                              code: 'LOCATION',
                              enumCode: 'LOCATION',
                            },
                          },
                          {
                            text: 'Located on Via Liguria, next to the Spanish Steps. Historic palazzo on the outside, a bold distortion of luxury inside, W Rome enters the scene in an unapologetically Italian way.',
                            type: {
                              code: 'SALES MESSAGE',
                              enumCode: 'SALES_MESSAGE',
                            },
                          },
                          {
                            text: 'Live Eternal',
                            type: {
                              code: 'HEADER MESSAGE',
                              enumCode: 'HEADER_MESSAGE',
                            },
                          },
                          {
                            text: '162 Rooms & Suites',
                            type: {
                              code: 'ROOM HEADER CAPTION',
                              enumCode: 'ROOM_HEADER_CAPTION',
                            },
                          },
                          {
                            text: null,
                            type: {
                              code: 'HOTEL MARKETING CAPTION',
                              enumCode: 'HOTEL_MARKETING_CAPTION',
                            },
                          },
                        ],
                        currency: 'EUR',
                        isRecentlyRenovated: true,
                        isFullyRenovated: false,
                        hasRenovatedRooms: false,
                        newLobby: false,
                        newProperty: false,
                        openingDate: '2021-12-06',
                        latitude: 41.90691,
                        longitude: 12.48917,
                        bookable: true,
                        hasUniquePropertyLogo: false,
                      },
                      reviews: {
                        stars: {
                          count: 4.7,
                        },
                        numberOfReviews: {
                          count: 151,
                        },
                      },
                      media: {
                        primaryImage: {
                          edges: [
                            {
                              node: {
                                title: 'Living Room',
                                imageUrls: {
                                  wideHorizontal: '/is/image/marriotts7prod/wh-romwv-living-room-54125:Wide-Hor',
                                  square: '/is/image/marriotts7prod/wh-romwv-living-room-54125:Square',
                                  classicHorizontal: '/is/image/marriotts7prod/wh-romwv-living-room-54125:Classic-Hor',
                                },
                              },
                            },
                          ],
                        },
                      },
                    },
                    rates: [
                      {
                        rateModes: {
                          lowestAverageRate: {
                            amount: {
                              amount: 78443,
                              currency: 'EUR',
                              decimalPoint: 2,
                            },
                            fees: {
                              amount: 0,
                              currency: 'EUR',
                              decimalPoint: 2,
                            },
                            taxes: {
                              amount: 1000,
                              currency: 'EUR',
                              decimalPoint: 2,
                            },
                            totalAmount: {
                              amount: 79443,
                              currency: 'EUR',
                              decimalPoint: 2,
                            },
                            amountPlusMandatoryFees: {
                              amount: 78443,
                              currency: 'EUR',
                              decimalPoint: 2,
                            },
                            mandatoryFees: {
                              amount: 0,
                              currency: 'EUR',
                              decimalPoint: 2,
                            },
                          },
                        },
                        membersOnly: false,
                        lengthOfStay: 7,
                        status: {
                          code: 'AvailableForSale',
                        },
                        rateCategory: {
                          code: 'StandardRates',
                          value: null,
                        },
                        sourceOfRate: 'MARSHA',
                      },
                    ],
                  },
                },
                {
                  node: {
                    distance: null,
                    property: {
                      id: 'ROMXR',
                      basicInformation: {
                        isMax: false,
                        resort: false,
                        isAdultsOnly: false,
                        brand: {
                          id: 'XR',
                          name: 'St. Regis',
                          type: 'SPG',
                          photos: [],
                        },
                        name: 'The St. Regis Rome',
                        nameInDefaultLanguage: 'The St. Regis Rome',
                        descriptions: [
                          {
                            text: 'Introduced to Rome society in 1894, the architecturally iconic St. Regis Rome is a historic hotel located in one of the city’s most impressive palazzos. The pioneer St. Regis in Europe and a social beacon for Romans and international travelers, our 5 star hotel has emerged to define a new era of luminosity. Blending a noble heritage with fearless, elegant interiors has transformed this grand dame into a supremely luxurious and artful residence. High-ceilinged and light-filled, the guestrooms and suites are styled with luxurious Rubelli fabrics, handmade glass and collectable curios – effortlessly sophisticated and distinctively urbane. A contemporary take on a historic address, our luxury hotel has shed its former bearing and stepped out, into the limelight to truly own Rome. Radiant and luminous, it combines fearless elegance, disruptive artistry and discerning enlightenment. Worried about leaving your furry friends behind? Bring them along! Our hotel is pet friendly and welcomes trained pets.',
                            type: {
                              code: 'DESCRIPTION',
                              enumCode: 'DESCRIPTION',
                            },
                          },
                          {
                            text: 'An illustrious landmark within the Eternal City,  St. Regis Rome is the premier address that stands resolutely on Piazza della Repubblica, providing a discrete and highly indulgent sanctuary.',
                            type: {
                              code: 'PROPERTY DESCRIPTION',
                              enumCode: 'SHORT_DESCRIPTION',
                            },
                          },
                          {
                            text: 'An illustrious landmark within the Eternal City,  St. Regis Rome is the premier address that stands resolutely on Piazza della Repubblica, providing a discrete and highly indulgent sanctuary.',
                            type: {
                              code: 'PROPERTY LONG DESCRIPTION',
                              enumCode: 'LONG_DESCRIPTION',
                            },
                          },
                          {
                            text: 'In the heart of Rome historical center, next to the Presidential Palace, walking distance to the Trevi Fountain the Spanish Steps and the shopping area',
                            type: {
                              code: 'LOCATION',
                              enumCode: 'LOCATION',
                            },
                          },
                          {
                            text: 'In the heart of Rome historical center, next to the Presidential Palace, walking distance to the Trevi Fountain the Spanish Steps and the shopping area',
                            type: {
                              code: 'SALES MESSAGE',
                              enumCode: 'SALES_MESSAGE',
                            },
                          },
                          {
                            text: 'Welcome to our 5 star hotel in Rome',
                            type: {
                              code: 'HEADER MESSAGE',
                              enumCode: 'HEADER_MESSAGE',
                            },
                          },
                          {
                            text: 'St.Regis Rome is the sanctuary of fearless elegance, disruptive artistry and discerning enlightment.',
                            type: {
                              code: 'HOTEL MARKETING CAPTION',
                              enumCode: 'HOTEL_MARKETING_CAPTION',
                            },
                          },
                        ],
                        currency: 'EUR',
                        isRecentlyRenovated: true,
                        isFullyRenovated: true,
                        hasRenovatedRooms: true,
                        newLobby: false,
                        newProperty: false,
                        openingDate: '1994-11-19',
                        latitude: 41.9037,
                        longitude: 12.495,
                        bookable: true,
                        hasUniquePropertyLogo: false,
                      },
                      reviews: {
                        stars: {
                          count: 4.6,
                        },
                        numberOfReviews: {
                          count: 879,
                        },
                      },
                      media: {
                        primaryImage: {
                          edges: [
                            {
                              node: {
                                title: 'Lobby',
                                imageUrls: {
                                  wideHorizontal: '/is/image/marriotts7prod/xr-romxr-lobby-15214:Wide-Hor',
                                  square: '/is/image/marriotts7prod/xr-romxr-lobby-15214:Square',
                                  classicHorizontal: '/is/image/marriotts7prod/xr-romxr-lobby-15214:Classic-Hor',
                                },
                              },
                            },
                          ],
                        },
                      },
                    },
                    rates: [
                      {
                        rateModes: {
                          lowestAverageRate: {
                            amount: {
                              amount: 111319,
                              currency: 'EUR',
                              decimalPoint: 2,
                            },
                            fees: {
                              amount: 0,
                              currency: 'EUR',
                              decimalPoint: 2,
                            },
                            taxes: {
                              amount: 12131,
                              currency: 'EUR',
                              decimalPoint: 2,
                            },
                            totalAmount: {
                              amount: 123451,
                              currency: 'EUR',
                              decimalPoint: 2,
                            },
                            amountPlusMandatoryFees: {
                              amount: 111319,
                              currency: 'EUR',
                              decimalPoint: 2,
                            },
                            mandatoryFees: {
                              amount: 0,
                              currency: 'EUR',
                              decimalPoint: 2,
                            },
                          },
                        },
                        membersOnly: false,
                        lengthOfStay: 7,
                        status: {
                          code: 'AvailableForSale',
                        },
                        rateCategory: {
                          code: 'StandardRates',
                          value: null,
                        },
                        sourceOfRate: 'DSP',
                      },
                    ],
                  },
                },
                {
                  node: {
                    distance: null,
                    property: {
                      id: 'VCEGL',
                      basicInformation: {
                        isMax: false,
                        resort: false,
                        isAdultsOnly: false,
                        brand: {
                          id: 'LC',
                          name: 'Luxury Collection',
                          type: 'SPG',
                          photos: [],
                        },
                        name: 'The Gritti Palace, a Luxury Collection Hotel, Venice',
                        nameInDefaultLanguage: 'The Gritti Palace, a Luxury Collection Hotel, Venice',
                        descriptions: [
                          {
                            text: 'Overlooking the Grand Canal in the heart of Venice, The Gritti Palace boasts one of the most enthralling views of the lagoon city - from the island of San Giorgio Maggiore past landmarks Punta della Dogana and Santa Maria della Salute Basilica to the Peggy Guggenheim Collection. Dating to 1475, this noble palace and luxury 5-star hotel is a place of exceptional art and elegance that has retained its reassuringly intimate and familiar feel of a private residence. A historical treasure where heritage and culture blend with renewed Venetian style, our hotel is a refined version of its iconic self, offering attentive service, a delectable culinary experience and new avenues for relaxation and pleasure. From the design of its signature suites and iconic terraces to the Gritti Epicurean School, Riva Yacht experiences and Riva Lounge and the Gritti SPA branded by Sisley Paris, The Gritti Palace is where multiple generations of elite global influencers gather to explore, taste, and celebrate.',
                            type: {
                              code: 'DESCRIPTION',
                              enumCode: 'DESCRIPTION',
                            },
                          },
                          {
                            text: 'Set on the Grand Canal in a tranquil corner of the city, The Gritti Palace is a place of exceptional art and elegance with an intimate, familiar feel. This luxury hotel is a historical treasure where heritage and culture blend with renewed Venetian style.',
                            type: {
                              code: 'PROPERTY DESCRIPTION',
                              enumCode: 'SHORT_DESCRIPTION',
                            },
                          },
                          {
                            text: 'Set on the Grand Canal in a tranquil corner of the city, The Gritti Palace is a place of exceptional art and elegance with an intimate, familiar feel. This luxury hotel is a historical treasure where heritage and culture blend with renewed Venetian style.',
                            type: {
                              code: 'PROPERTY LONG DESCRIPTION',
                              enumCode: 'LONG_DESCRIPTION',
                            },
                          },
                          {
                            text: 'Overlooking the Grand Canal, The Gritti Palace, a Luxury Collection Hotel, Venice boasts enthralling views that span from S. Giorgio Maggiore to the Peggy Guggenheim Collection. Piazza San Marco is a short stroll past antique shops and designer boutiques.',
                            type: {
                              code: 'LOCATION',
                              enumCode: 'LOCATION',
                            },
                          },
                          {
                            text: 'Overlooking the Grand Canal, The Gritti Palace, a Luxury Collection Hotel, Venice boasts enthralling views that span from S. Giorgio Maggiore to the Peggy Guggenheim Collection. Piazza San Marco is a short stroll past antique shops and designer boutiques.',
                            type: {
                              code: 'SALES MESSAGE',
                              enumCode: 'SALES_MESSAGE',
                            },
                          },
                          {
                            text: 'Discover the iconic Grand Canal from our luxury Venice hotel',
                            type: {
                              code: 'HEADER MESSAGE',
                              enumCode: 'HEADER_MESSAGE',
                            },
                          },
                          {
                            text: "Venice's finest collection of luxury hotel rooms and suites",
                            type: {
                              code: 'ROOM HEADER CAPTION',
                              enumCode: 'ROOM_HEADER_CAPTION',
                            },
                          },
                          {
                            text: 'Art and elegance combine in this iconic Grand Canal luxury hotel in the heart of Venice, Italy.',
                            type: {
                              code: 'HOTEL MARKETING CAPTION',
                              enumCode: 'HOTEL_MARKETING_CAPTION',
                            },
                          },
                        ],
                        currency: 'EUR',
                        isRecentlyRenovated: false,
                        isFullyRenovated: false,
                        hasRenovatedRooms: false,
                        newLobby: false,
                        newProperty: false,
                        openingDate: '1994-11-19',
                        latitude: 45.431637,
                        longitude: 12.33325,
                        bookable: true,
                        hasUniquePropertyLogo: false,
                      },
                      reviews: {
                        stars: {
                          count: 4.8,
                        },
                        numberOfReviews: {
                          count: 549,
                        },
                      },
                      media: {
                        primaryImage: {
                          edges: [
                            {
                              node: {
                                title: 'vcegl-lifestyle-2104',
                                imageUrls: {
                                  wideHorizontal:
                                    '/content/dam/marriott-renditions/VCEGL/vcegl-lifestyle-2104-hor-wide.jpg',
                                  square: '/content/dam/marriott-renditions/VCEGL/vcegl-lifestyle-2104-sq.jpg',
                                  classicHorizontal:
                                    '/content/dam/marriott-renditions/VCEGL/vcegl-lifestyle-2104-hor-clsc.jpg',
                                },
                              },
                            },
                          ],
                        },
                      },
                    },
                    rates: [
                      {
                        rateModes: {
                          lowestAverageRate: {
                            amount: {
                              amount: 165142,
                              currency: 'EUR',
                              decimalPoint: 2,
                            },
                            fees: {
                              amount: 0,
                              currency: 'EUR',
                              decimalPoint: 2,
                            },
                            taxes: {
                              amount: 357,
                              currency: 'EUR',
                              decimalPoint: 2,
                            },
                            totalAmount: {
                              amount: 165500,
                              currency: 'EUR',
                              decimalPoint: 2,
                            },
                            amountPlusMandatoryFees: {
                              amount: 165142,
                              currency: 'EUR',
                              decimalPoint: 2,
                            },
                            mandatoryFees: {
                              amount: 0,
                              currency: 'EUR',
                              decimalPoint: 2,
                            },
                          },
                        },
                        membersOnly: false,
                        lengthOfStay: 7,
                        status: {
                          code: 'AvailableForSale',
                        },
                        rateCategory: {
                          code: 'StandardRates',
                          value: null,
                        },
                        sourceOfRate: 'DSP',
                      },
                    ],
                  },
                },
                {
                  node: {
                    distance: null,
                    property: {
                      id: 'VCEXR',
                      basicInformation: {
                        isMax: false,
                        resort: false,
                        isAdultsOnly: false,
                        brand: {
                          id: 'XR',
                          name: 'St. Regis',
                          type: 'SPG',
                          photos: [],
                        },
                        name: 'The St. Regis Venice',
                        nameInDefaultLanguage: 'The St. Regis Venice',
                        descriptions: [
                          {
                            text: 'Avant-garde in outlook and design, The St. Regis Venice merges striking, modern interiors with its historic provenance as the best address in the city. Flanked by the Grand Canal with views across iconic landmarks, the hotel has stood in this privileged position for over a century and a half. Stylish design, intelligent technology and St. Regis Butlers cultivate an environment of impeccable comfort in 126 guestrooms and 37 suites, a selection of which graced with private terrace. The preserve for relaxation and socializing, our Italianate garden presents access to a range of dining and beverage options at Gio’s Restaurant and Terrace, the St. Regis Bar and at Arts Bar. A choice of areas transform easily to host up to 110 guests for celebrations, weddings and meetings, while the SPA Suites and an Exercise Room provide avenues for unwinding. Behind the hotel, luxury boutiques and contemporary art galleries lead the visitor to Teatro La Fenice and the treasures of Piazza San Marco, just four minutes away.',
                            type: {
                              code: 'DESCRIPTION',
                              enumCode: 'DESCRIPTION',
                            },
                          },
                          {
                            text: 'Celebrating the modern tastemaker, The St. Regis Venice has been defined by the city’s artistic and cultural legacy and offers views across the Grand Canal and Venice’s most iconic landmarks. Piazza San Marco is just a four-minute walk from the hotel.',
                            type: {
                              code: 'PROPERTY DESCRIPTION',
                              enumCode: 'SHORT_DESCRIPTION',
                            },
                          },
                          {
                            text: 'Celebrating the modern tastemaker, The St. Regis Venice has been defined by the city’s artistic and cultural legacy and offers views across the Grand Canal and Venice’s most iconic landmarks. Piazza San Marco is just a four-minute walk from the hotel.',
                            type: {
                              code: 'PROPERTY LONG DESCRIPTION',
                              enumCode: 'LONG_DESCRIPTION',
                            },
                          },
                          {
                            text: "Immersed in Venice's luxury shopping area, The St. Regis Venice faces the Grand Canal opposite Santa Maria della Salute Church and Punta della Dogana Art Museum. The cultural attractions of Piazza San Marco and Gran Teatro La Fenice are steps away.",
                            type: {
                              code: 'LOCATION',
                              enumCode: 'LOCATION',
                            },
                          },
                          {
                            text: "Immersed in Venice's luxury shopping area, The St. Regis Venice faces the Grand Canal opposite Santa Maria della Salute Church and Punta della Dogana Art Museum. The cultural attractions of Piazza San Marco and Gran Teatro La Fenice are steps away.",
                            type: {
                              code: 'SALES MESSAGE',
                              enumCode: 'SALES_MESSAGE',
                            },
                          },
                          {
                            text: 'Welcome to our 5 star hotel in the heart of Venice',
                            type: {
                              code: 'HEADER MESSAGE',
                              enumCode: 'HEADER_MESSAGE',
                            },
                          },
                          {
                            text: 'An unprecedented balance of destination and lifestyle.',
                            type: {
                              code: 'ROOM HEADER CAPTION',
                              enumCode: 'ROOM_HEADER_CAPTION',
                            },
                          },
                          {
                            text: "Avant-garde in outlook The St. Regis Venice unfolds a new era of glamour at the city's best address",
                            type: {
                              code: 'HOTEL MARKETING CAPTION',
                              enumCode: 'HOTEL_MARKETING_CAPTION',
                            },
                          },
                        ],
                        currency: 'EUR',
                        isRecentlyRenovated: true,
                        isFullyRenovated: false,
                        hasRenovatedRooms: false,
                        newLobby: false,
                        newProperty: false,
                        openingDate: '2019-08-22',
                        latitude: 45.431933,
                        longitude: 12.33549,
                        bookable: true,
                        hasUniquePropertyLogo: false,
                      },
                      reviews: {
                        stars: {
                          count: 4.7,
                        },
                        numberOfReviews: {
                          count: 316,
                        },
                      },
                      media: {
                        primaryImage: {
                          edges: [
                            {
                              node: {
                                title: 'Hotel_Facade 16059',
                                imageUrls: {
                                  wideHorizontal: '/is/image/marriotts7prod/xr-vcexr-vcexr-hotel-facade-16059:Wide-Hor',
                                  square: '/is/image/marriotts7prod/xr-vcexr-vcexr-hotel-facade-16059:Square',
                                  classicHorizontal:
                                    '/is/image/marriotts7prod/xr-vcexr-vcexr-hotel-facade-16059:Classic-Hor',
                                },
                              },
                            },
                          ],
                        },
                      },
                    },
                    rates: [
                      {
                        rateModes: {
                          lowestAverageRate: {
                            amount: {
                              amount: 128285,
                              currency: 'EUR',
                              decimalPoint: 2,
                            },
                            fees: {
                              amount: 0,
                              currency: 'EUR',
                              decimalPoint: 2,
                            },
                            taxes: {
                              amount: 357,
                              currency: 'EUR',
                              decimalPoint: 2,
                            },
                            totalAmount: {
                              amount: 128642,
                              currency: 'EUR',
                              decimalPoint: 2,
                            },
                            amountPlusMandatoryFees: {
                              amount: 128285,
                              currency: 'EUR',
                              decimalPoint: 2,
                            },
                            mandatoryFees: {
                              amount: 0,
                              currency: 'EUR',
                              decimalPoint: 2,
                            },
                          },
                        },
                        membersOnly: false,
                        lengthOfStay: 7,
                        status: {
                          code: 'AvailableForSale',
                        },
                        rateCategory: {
                          code: 'StandardRates',
                          value: null,
                        },
                        sourceOfRate: 'MARSHA',
                      },
                    ],
                  },
                },
              ],
              geoCodeInfo: null,
              nlpEntities: null,
              ampRequest: {
                productQueriesHospitality: {
                  agentInfo: null,
                  altCustId: null,
                  includeMandatoryFees: true,
                  includeTaxesAndFees: false,
                  priceModifiers: {
                    rateRequest: [
                      {
                        rateRequestTypeEnum: 'Standard',
                        rateRequestValue: null,
                      },
                    ],
                  },
                  roomStayQueryProduct: {
                    baseHospitalityFacilityQuery: {
                      numberOfRooms: 1,
                      timespan: {
                        startDate: '2026-04-15',
                        endDate: '2026-04-22',
                      },
                      guestCounts: [
                        {
                          age: null,
                          count: 1,
                        },
                      ],
                      numberOfNights: null,
                    },
                  },
                },
              },
            },
          },
        },
      },
    },
  },
  intent: 'hotel_search',
  toolsUsed: ['nls_hotel_search'],
  response:
    'Italy is a masterpiece waiting to be explored — here is a curated 7-day journey through Rome, Florence, and Venice for your April escape:\n\nWould you like me to look into specific amenities or dining options at any of these Italian icons?',
  chatId: '8234adfe-79cd-4325-9461-588823700b15',
  uiData: {
    categoryList: [
      {
        aiDescription:
          "Start your journey in the Eternal City, where ancient history meets modern luxury. From the Spanish Steps to the Trevi Fountain, Rome's grandeur is unmatched.",
        categoryName: 'Rome: The Eternal City (Days 1-3)',
        properties: [
          {
            aiDescription:
              'A masterclass in Italian craftsmanship located in the heart of the Campo Marzio neighborhood.',
            propertyId: 'ROMBG',
          },
          {
            aiDescription: 'A sanctuary of fearless elegance and disruptive artistry near the Presidential Palace.',
            propertyId: 'ROMXR',
          },
          {
            aiDescription: 'A bold distortion of luxury housed in a historic palazzo steps from the Spanish Steps.',
            propertyId: 'ROMWV',
          },
        ],
      },
      {
        aiDescription:
          'Travel north to the cradle of the Renaissance. Florence offers world-class art, stunning architecture along the Arno, and the gateway to Tuscany.',
        categoryName: 'Florence: Renaissance Romance (Days 4-5)',
        properties: [
          {
            aiDescription: 'An optimal base on the Arno river for exploring the Uffizi and the Duomo.',
            propertyId: 'FLRXR',
          },
        ],
      },
      {
        aiDescription:
          'Conclude your week in the City of Canals. Experience the avant-garde glamour and historic charm of Venice from the best addresses on the Grand Canal.',
        categoryName: 'Venice: Floating Elegance (Days 6-7)',
        properties: [
          {
            aiDescription: 'Iconic luxury on the Grand Canal with enthralling views of Santa Maria della Salute.',
            propertyId: 'VCEGL',
          },
          {
            aiDescription: 'A new era of glamour overlooking the Grand Canal opposite Punta della Dogana.',
            propertyId: 'VCEXR',
          },
        ],
      },
    ],
    followUp: 'Would you like me to look into specific amenities or dining options at any of these Italian icons?',
    intro:
      'Italy is a masterpiece waiting to be explored — here is a curated 7-day journey through Rome, Florence, and Venice for your April escape:',
    mChipGroup: {
      mQuickSelectChip: [
        {
          text: 'Tell me about the pools in Rome',
          type: 'text',
        },
        {
          text: 'Dining at The Gritti Palace',
          type: 'text',
        },
        {
          text: 'Florence hotel amenities',
          type: 'text',
        },
      ],
    },
  },
  uiType: 'categoryList',
  metadata: {
    executionTime: 0,
  },
};
